"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M11 11h5v5h-5zm-7 0h5v5H4zm0-7h12v5H4z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M20 6v14H6v2h14c1.1 0 2-.9 2-2V6z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M18 16V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2M4 4h12v5H4zm5 12H4v-5h5zm2-5h5v5h-5z"
}, "2")], 'BackupTableTwoTone');